var render, staticRenderFns
import script from "./EventBus.vue?vue&type=script&lang=js&"
export * from "./EventBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fbc98744', component.options)
    } else {
      api.reload('fbc98744', component.options)
    }
    
  }
}
component.options.__file = "src/components/Modules/EventBus.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/EventBus.vue
// module id = PEr6
// module chunks = 0